import React, { useState, useEffect, useRef } from 'react';
import { useSnackbar } from 'notistack';
import {
  Box,
  FormControl,
  Select,
  InputLabel,
  MenuItem,
  Divider,
  Button,
  Typography,
  CircularProgress,
} from '@mui/material';
import { getYears } from '../../utils/constCodeUtils';
import { vendorDeptHeaders } from '../../utils/vendorStaticData';
import * as xlsx from 'xlsx';
import * as staticsApi from '../../lib/api/project';
import VendorDeptStateTable from '../../components/vendor_dept_stat/VendorDeptStateTable';

const VendorDeptStatContainer = () => {
  const tableRef = useRef();

  const [years, setYears] = useState(null);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());

  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);

  useEffect(() => {
    const arrYears = getYears(3, 1);
    setYears(arrYears);
  }, []);

  const handleChangeYear = (event) => {
    setSelectedYear(event.target.value);
  };

  const handleDownExcel = () => {
    const el = tableRef;
    const name = '매출처별 통계';
    //console.log('handleDownload click')
    htmlToExcel(el.current, name);
  };

  const htmlToExcel = (tableEl, name) => {
    const wb = xlsx.utils.table_to_book(tableEl, {
      sheet: 'sheet1',
      raw: true,
    });
    xlsx.writeFile(wb, name + '.xlsx');
  };

  const onLoadData = async () => {
    setLoading(true);

    try {
      const res = await staticsApi.getProjectsDeptSalesStatics(selectedYear);
      if (res.data.list) {
        //console.log(res.data.list, 'res.data.list');
        setData(res.data.list);
      }
    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
    setLoading(false);
  };

  useEffect(() => {
    if (selectedYear) {
      //const tempData = makeDataPrjDeptStat();
      //console.log(JSON.stringify(tempData));
      //setData(tempData);
      onLoadData();
    }
  }, [selectedYear]);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', my: 2 }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-start',
            alignItems: 'center',
          }}
        >
          <Box sx={{ mr: 1, minWidth: 120 }}>
            <FormControl variant="standard" fullWidth>
              <InputLabel id="selected-year-label">기준년도</InputLabel>
              <Select
                labelId="selected-year-label"
                id="selected-year"
                value={selectedYear}
                label="년도"
                onChange={handleChangeYear}
              >
                {years &&
                  years.map((item, index) => (
                    <MenuItem key={index} value={item}>
                      {item}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Box>
        </Box>

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-start',
            alignItems: 'center',
          }}
        >
          <Box>
            <Button
              variant="contained"
              color="success"
              onClick={handleDownExcel}
            >
              엑셀 다운로드
            </Button>
          </Box>
        </Box>
      </Box>
      <Divider sx={{ my: 1 }} />

      <Box
        sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
      >
        {loading ? (
          <Box sx={{ display: 'flex' }}>
            <CircularProgress />
          </Box>
        ) : Array.isArray(data) && data.length === 0 ? (
          <Box>
            <Typography variant="subtitle2">데이터가 없습니다.</Typography>
          </Box>
        ) : (
          <VendorDeptStateTable
            headerRows={vendorDeptHeaders}
            tableRef={tableRef}
            data={data}
            selectedYear={selectedYear}
          />
        )}
      </Box>
    </Box>
  );
};
export default VendorDeptStatContainer;
